export enum TypeOrdersListEnum {
  notDraft = 0,
  carts = 1,
  customers = 2,
  agencies = 3
}

